import React, { useState, useEffect } from 'react'
import "./css/AreaReg.css"
import NavImg from "./images/icons/nav.png"

function AreaReg() {
	const [dateTime, setDateTime] = useState(new Date());
	const [signupSuccess, setSignupSuccess] = useState(false);

	const [formData, setFormData] = useState({
		userFullName: "",
		userMob: "",
		userEmail: "",
		userType: "",
		userName: "",
		userPassword: "",
	});

	const [errors, setErrors] = useState({
		userEmail: "",
		userMob: "",
		userPassword: "",
	});

	const formattedDateTime = dateTime.toLocaleString();
	//Function to handle input changes
	const handleInputChange = (event, setInputValue) => {
		setInputValue(event.target.value);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		// //("submit button clicked");

		const {
			userFullName,
			userMob,
			userEmail,
			userType,
			userName,
			userPassword,
		} = formData;

		const emailValid = validateEmail(userEmail);
		const mobilenumberValid = validateMobilenumber(userMob);
		const passwordValid = validatePassword(userPassword);

		const validateEmail = (userEmail) => {
			// Basic email validation
			const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			return pattern.test(userEmail);
		};
	
		const validateMobilenumber = (userMob) => {
			// Check for 10-digit number
			return /^\d{10}$/.test(userMob);
		};
	
		const validatePassword = (userPassword) => {
			// Check for minimum 8 characters
			return userPassword.length >= 8;
		};
		if (!emailValid) {
			setErrors({ ...errors, userEmail: "Invalid email address." });
			alert(
				"Invalid E-Mail Address"
			)
		} else if (!mobilenumberValid) {
			setErrors({ ...errors, userMob: "Invalid mobile number." });
			alert(
				"Invalid Mobile Number"
			)
		} else if (!passwordValid) {
			setErrors({
				...errors,
				userPassword: "Password must be at least 8 characters long.",
			});
			alert(
				"Invalid password"
			)
		} else {
			try {
				const response = await fetch("http://localhost:1017/Areaistrations", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						userFullName,
						userMob,
						userEmail,
						userType,
						userName,
						userPassword,
					}),
				});

				if (response.ok) {
					// Registration successful
					setSignupSuccess(true); // Set the signup success state
					setFormData({
						// Clear form data
						userFullName: "",
						userMob: "",
						userEmail: "",
						userType: "",
						userName: "",
						userPassword: "",
					});
				} else {
					// Registration failed
					console.error("Registration failed");
				}
			} catch (error) {
				console.error("Error connecting to the server:", error);
			}
		}
	};
	return (
		<div className='AreaPageContentDivMain'>
			<div className='AreaNavBar_KOT'>
				<div className='NavBar_KOT_Logo_Btn'>
					<img src={NavImg} alt="?" />
					<span className='TitleText_KOT'>SherDine</span>
				</div>
				<div className='DateTime'>
					{formattedDateTime}
				</div>
			</div>
			<div className='AreaPageContentInput'>
				<form className="Areaform" onSubmit={handleSubmit}>
					<div className="AreaformContent">
						<div className="AreaformLeft">
							<div className="AreaformLeftDivName">
								<label className="AreaformLeftName">
									Name
								</label>
								<input
									className="AreaformName"
									type="text"
									value={formData.userFullName}
									onChange={(e) =>
										setFormData({ ...formData, userFullName: e.target.value })
									}
								/>
							</div>
							<div className="AreaformLeftDivUserName">
								<label className="AreaformLeftUserName">
									User Name
								</label>
								<input
									className="AreaformUserName"
									type="text"
									value={formData.userName}
									onChange={(e) =>
										setFormData({ ...formData, userName: e.target.value })
									}
								/>
							</div>
							<div className="AreaformLeftDivPass">
								<label className="AreaformLeftPass">
									Password
								</label>
								<input
									className="AreaformPassword"
									type="text"
									value={formData.userPassword}
									onChange={(e) =>
										setFormData({ ...formData, userPassword: e.target.value })
									}
								/>
							</div>
							<div className="AreaformLeftDivUserPass">
								<label className="AreaformLeftUserPass">
									User Password
								</label>
								<input
									className="AreaformUserPassword"
									type="text"
									value={formData.userPassword}
									onChange={(e) =>
										setFormData({ ...formData, userPassword: e.target.value })
									}
								/>
							</div>
						</div>
						<div className="AreaformRight">
							<div className="AreaformRightUserType">
								<label className="AreaformRightUserTypeDiv">
									User Type
								</label>
								<input
									className="AreaformUserType"
									type="text"
									value={formData.userType}
									onChange={(e) =>
										setFormData({ ...formData, userType: e.target.value })
									}
								/>
							</div>
							<div className="AreaformRightUserCode">
								<label className="AreaformRightUserCodeDiv">
									User Code
								</label>
								<input
									className="AreaformUserCode"
									type="text"
									value={formData.userMob}
									onChange={(e) =>
										setFormData({ ...formData, userMob: e.target.value })
									}
								/>
							</div>
							<div className="AreaformRightPhone">
								<label className="AreaformRightPhoneDiv">
									Phone
								</label>
								<input
									className="AreaformPhone"
									type="number"
									value={formData.userMob}
									onChange={(e) =>
										setFormData({ ...formData, userMob: e.target.value })
									}
								/>
							</div>
							<div className="AreaformRightSwipeCode">
								<label className="AreaformRightSwipeCodeDiv">
									Swipe Code
								</label>
								<input
									className="AreaformSwipeCode"
									type="email"
									value={formData.userEmail}
									onChange={(e) =>
										setFormData({ ...formData, userEmail: e.target.value })
									}
								/>
							</div>
						</div>
					</div>
					<div className="AreaContentBtns">
						<button type="button" className="btn btn-outline-light AreaContentCancelBtn">
							Cancel
						</button>
						<button type="submit" className="btn btn-outline-danger AreaContentSubmitBtn">
							Submit
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}

export default AreaReg
